import { render, staticRenderFns } from "./AdDetail.vue?vue&type=template&id=0c2f1321&scoped=true"
import script from "./AdDetail.vue?vue&type=script&lang=js"
export * from "./AdDetail.vue?vue&type=script&lang=js"
import style0 from "./AdDetail.vue?vue&type=style&index=0&id=0c2f1321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f1321",
  null
  
)

export default component.exports